module.exports = "https://cwa.roocdn.com/_next/static/location-unknown.1fdb2c5c.svg";